var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneySign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.98 54.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "moneySign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1196.43,1158c5.42-13.22,22.71-16.89,35.3-11.73s18.41,20.06,13,33.28-20,19.74-32.61,14.58S1191,1171.19,1196.43,1158Z",
    transform: "translate(-1193.27 -1142.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1218.75,1159.58c1-.21,2.17-.43,3.59-.65a9.72,9.72,0,0,0-.54,4.71c.11,2.24,0,3.72-.51,4.42,0-.06-.61-.7-1.75-1.92a16.28,16.28,0,0,1-2.16-2.69,2.19,2.19,0,0,1,0-2.6c-.09-.64.36-1.07,1.33-1.27m6.86,16.7c.27-.45.47-.67.6-.67s.55.25,1.08.77c-.3.14-.61.29-.92.42a2.68,2.68,0,0,1-1,.2l-.89,0a1.28,1.28,0,0,0,1.17-.67M1229,1154a2.1,2.1,0,0,0-1.38-1,3.88,3.88,0,0,0-3.47,2.12,4.17,4.17,0,0,1-3.85,2.11,21.57,21.57,0,0,1-2.72-.24q-3.94,1.07-5,2.5a3,3,0,0,0,0,3.37,25.55,25.55,0,0,0,4.36,4.8,25.39,25.39,0,0,1,4.51,5.1,3.85,3.85,0,0,1,.54,2.52,3.41,3.41,0,0,1-1.61,2.09c-.84-.12-2.47-.28-4.9-.45s-4.25-.38-5.46-.6c-.19.35.07.65.78.91s1.56.58,2.53,1a17.94,17.94,0,0,1,4.23.36,2.63,2.63,0,0,1,1.73,1.08c.25.48.08,1.52-.53,3.12s-.69,2.83-.23,3.7A4.23,4.23,0,0,0,1220,1188a10.25,10.25,0,0,0,1.88.29c.9,0,1.12-.42.67-1.25-.13-.26-.27-.51-.4-.75s-.25-.47-.37-.69a3.33,3.33,0,0,1-.32-.87.65.65,0,0,1,.3-.76c.31-.84.73-1.88,1.26-3.15s2.21-1.89,5.06-1.89a7.54,7.54,0,0,0,2.74-.7c.84-.4,1.11-.89.8-1.47a7.28,7.28,0,0,0-1.89-1.56,9.07,9.07,0,0,1-2.83-3.29q-1.59-3-.06-7.36a30.77,30.77,0,0,0,1.67-5.91c1.47,0,2.13-.14,2-.43a6.38,6.38,0,0,0-1.43-1,5,5,0,0,1-1.47-1c-.24-.44.17-.76,1.21-1a.81.81,0,0,0,.23-1.19",
    transform: "translate(-1193.27 -1142.51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySign);
export default __webpack_public_path__ + "static/media/moneySign.e2fc3a44.svg";
export { ForwardRef as ReactComponent };